<template>
  <div class="d-flex flex-wrap align-items-start">
    <div class="kit__utils__avatar kit__utils__avatar--size64 mr-3">
    </div>
    <div>
      <div class="text-uppercase font-size-12">{{ $store.state.user.role }}</div>
      <div class="text-dark font-weight-bold font-size-18 mb-2">{{ $store.state.user.name }}</div>
    </div>
    <div class="table-responsive mt-3">
      <table class="table table-borderless">
        <tbody>
          <tr>
            <td class="text-gray-6 pl-0">Email Address</td>
            <td class="pr-0 text-right text-dark">{{ $store.state.user.email }}</td>
          </tr>
          <tr>
            <td class="text-gray-6 pl-0">Subscription Plan</td>
            <td class="pr-0 text-right text-dark">
              {{ $store.state.user.tier | capitalize }}
            </td>
          </tr>
          <tr v-if="$store.state.user.isSubscribed">
            <td class="text-gray-6 pl-0"></td>
            <td class="pr-0 text-right text-dark">
              <a-button
                type="success"
                size="small"
                :style="{ backgroundColor: '#19D797', borderColor: '#19D797', color: 'white' }"
                :loading="upgradeBtnLoading"
                class="mr-2"
                @click="openStripePortal('upgrade')"
              >
                Change Plan
              </a-button>
              <a-button
                type="danger"
                size="small"
                :loading="cancelBtnLoading"
                @click="openStripePortal('cancel')"
              >
                Cancel
              </a-button>
            </td>
          </tr>
          <tr v-if="!$store.state.user.isSubscribed">
            <td class="text-gray-6 pl-0"></td>
            <td class="pr-0 text-right text-dark">
              <a-button
                type="success"
                size="small"
                :style="{ backgroundColor: '#19D797', borderColor: '#19D797', color: 'white' }"
                :loading="upgradeBtnLoading"
                class="mr-2"
                @click="$router.push('/account/pricing')"
              >
                Upgrade Now
              </a-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import * as firebase from '@/services/firebase'

export default {
  name: 'profile1',
  data() {
    return {
      upgradeBtnLoading: false,
      cancelBtnLoading: false,
      supportEmail: 'support@nursingexampro.com',
      premiumTiers: ['pro', 'unlimited'],
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  methods: {
    async openStripePortal(action) {
      if (action === 'cancel') {
        this.cancelBtnLoading = true
      } else {
        this.upgradeBtnLoading = true
      }
      await firebase.firebaseFunctions.httpsCallable('getStripePortalUrl')()
        .then(res => {
          console.log('url: ' + res.data)
          window.location.href = res.data
        })
        .catch(error => {
          console.log(error.message)
        })
    },
  },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
